import { HoursRange, WorkingHours, WorkingHoursRange } from '../../lead-generation/shared/domain/WorkingHours';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import hoursRegex from '../../lead-generation/shared/regex/hoursRegex';
import hoursRangeFormValidator from './working-hours-range/hours-range-form.validator';
import daysRangeFormValidator from './working-hours-range/days-range-form.validator';

const hoursValidator = Validators.pattern(hoursRegex);

export const createHoursRange = ({ from, to }: HoursRange, fb: FormBuilder): FormGroup =>
  fb.group(
    {
      from: fb.control(from, [hoursValidator, Validators.required]),
      to: fb.control(to, [hoursValidator, Validators.required])
    },
    { validator: hoursRangeFormValidator }
  );

export const createRange = (range: WorkingHoursRange, fb: FormBuilder): FormGroup => {
  const hours = range.hours.map(hoursRange => createHoursRange(hoursRange, fb));

  return fb.group(
    {
      hours: fb.array(hours),
      days: fb.array(range.days)
    },
    { validator: daysRangeFormValidator }
  );
};

export const createGroup = (workingHorus: WorkingHours, timezone: string, fb: FormBuilder): FormGroup => {
  const ranges = workingHorus.ranges.map((range: WorkingHoursRange) => createRange(range, fb));

  return fb.group({
    enabled: workingHorus.enabled,
    timezone,
    ranges: fb.array(ranges)
  });
};
